
import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import axios from "axios";
@Component({
  components: {},
})
class Jobdetail extends Vue {
  job: any = {};
  html: any = {};
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newVal: Route) {
    this.getSingleJob(newVal.params.id);
  }
  mounted() {
    console.log("jobdetail");
    const elm = document.querySelector<HTMLElement>(".k-header")!;
    if (elm) elm.style.display = "none";
    const elm2 = document.querySelectorAll<HTMLElement>(".k-c2a-banner")!;
    elm2.forEach((element) => {
      if (element) element.style.display = "none";
    });
    const elm3 = document.querySelector<HTMLElement>(".k-steps")!;
    if (elm3) elm3.style.display = "none";
    const elm4 = document.querySelector<HTMLElement>(".k-threecol-team")!;
    if (elm4) elm4.style.display = "none";
    this.getSingleJob(this.$route.params.id);
  }
  back(): void {
    this.$router.push({ name: "Home" });
  }
  getSingleJob(uid: string) {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url:
        "https://api.softgarden.io/api/rest/v3/frontend/jobslist/119569_extern/job/" +
        uid,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic ODFhOWYzNTUtMWI3OC00MWIxLWIyOTAtMjA4ZGM5OGQ4NWI3Og==",
      },
    };

    axios
      .request(config)
      .then((response: { data: any }) => {
        this.job = response.data;
        this.html = response.data.jobAdText.split("\n\n");
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
}
export default Jobdetail;
